import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authState } from "../../Atom";
import { useRecoilState } from "recoil";
import "./NavBar.css";

const navLinks = [
  "users",
  "transactions",
  "insights",
  "reservations",
  "notifications",
  "mastersetting",
  "blogs",
  "reports",
];

function NavBar() {
  const [previousIndex, setPreviousIndex] = useState(-10);
  const [openDropdown, setopenDropdown] = useState(false);
  const [userAuth, setUserAuth] = useRecoilState(authState);

  function handleNavClick(e) {
    console.log(e.target.id);
    document
      .getElementById(previousIndex)
      .parentNode.classList.remove("navLink-clicked");
    document
      .getElementById(e.target.id)
      .parentNode.classList.add("navLink-clicked");
    setPreviousIndex(e.target.id);
  }

  const logOutUser = () => {
    setUserAuth(null);
    window.location.replace("/");
  };

  return (
    <div className="header">
      <img className="logo" src="./images/logo.png" alt="Company-logo" />
      <div className="nav-links">
        <ul>
          <li className="links navLink-clicked">
            <Link
              id="-10"
              to={`/restaurants`}
              onClick={(e) => handleNavClick(e)}
            >
              Restaurant
            </Link>
          </li>
          {navLinks.map((navs, index) => (
            <li className="links">
              <Link
                id={index * -1}
                to={`/${navs}`}
                onClick={(e) => handleNavClick(e)}
              >
                {navs}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="menu">
        <button>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5282 2.33057C9.72742 1.83818 10.0691 1.41651 10.5096 1.1196C10.95 0.822684 11.469 0.664062 12.0002 0.664062C12.5314 0.664063 13.0504 0.822684 13.4908 1.1196C13.9313 1.41651 14.273 1.83818 14.4722 2.33057C16.4439 2.87281 18.183 4.04731 19.4225 5.67368C20.6621 7.30005 21.3334 9.28836 21.3335 11.3332V17.5959L23.7762 21.2599C23.9102 21.4607 23.9871 21.6941 23.9988 21.9352C24.0105 22.1763 23.9566 22.4161 23.8427 22.6289C23.7288 22.8418 23.5593 23.0197 23.3522 23.1437C23.1451 23.2678 22.9083 23.3333 22.6669 23.3332H16.6202C16.4597 24.444 15.9043 25.4598 15.0558 26.1945C14.2073 26.9292 13.1225 27.3335 12.0002 27.3335C10.8779 27.3335 9.79308 26.9292 8.9446 26.1945C8.09612 25.4598 7.54074 24.444 7.3802 23.3332H1.33353C1.09214 23.3333 0.85527 23.2678 0.648188 23.1437C0.441105 23.0197 0.27158 22.8418 0.157701 22.6289C0.0438213 22.4161 -0.010141 22.1763 0.00157046 21.9352C0.0132819 21.6941 0.0902279 21.4607 0.2242 21.2599L2.66687 17.5959V11.3332C2.66687 7.03457 5.57353 3.41323 9.5282 2.33057ZM10.1149 23.3332C10.2526 23.7234 10.5079 24.0613 10.8457 24.3003C11.1835 24.5393 11.5871 24.6676 12.0009 24.6676C12.4146 24.6676 12.8182 24.5393 13.156 24.3003C13.4938 24.0613 13.7492 23.7234 13.8869 23.3332H10.1135H10.1149ZM12.0002 4.66657C10.2321 4.66657 8.5364 5.36894 7.28615 6.61919C6.03591 7.86943 5.33353 9.56512 5.33353 11.3332V17.9999C5.33359 18.2633 5.25565 18.5208 5.10953 18.7399L3.82553 20.6666H20.1735L18.8895 18.7399C18.7439 18.5206 18.6664 18.2631 18.6669 17.9999V11.3332C18.6669 9.56512 17.9645 7.86943 16.7142 6.61919C15.464 5.36894 13.7683 4.66657 12.0002 4.66657V4.66657Z"
              fill="white"
            />
          </svg>
        </button>

        <div className="relative inline-block text-left ml-4">
          <div>
            <button
              onClick={() => setopenDropdown(!openDropdown)}
              type="button"
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
              id="menu-button"
              aria-expanded="true"
              aria-haspopup="true"
              style={{ height: "35px", fontSize: "12px" }}
            >
              My Account
              {/* Heroicon name: solid/chevron-down */}
              <svg
                className="-mr-1 ml-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {openDropdown && (
            <div
              className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              style={{ zIndex: "99" }}
            >
              <div className="py-1" role="none" style={{ zIndex: "99" }}>
                {/* Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" */}
                <a
                  href="#"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex={-1}
                  id="menu-item-0"
                >
                  Account settings
                </a>
                <a
                  href="#"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex={-1}
                  id="menu-item-1"
                >
                  IT Support
                </a>
                <form method="POST" action="#" role="none">
                  <button
                    onClick={() => logOutUser()}
                    type="submit"
                    className="text-gray-700 block w-full text-left px-4 py-2 text-sm"
                    role="menuitem"
                    tabIndex={-1}
                    id="menu-item-3"
                  >
                    Sign out
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
